import { m } from 'framer-motion';
import NextLink from 'next/link';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Button, Container, Typography } from '@mui/material';
// components
import { varFade } from '../../components/animate';
// routes
import { PATH_PAGE } from '../../routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingBottom: theme.spacing(10),
  },
}));

// ----------------------------------------------------------------------

export default () => (
  <RootStyle>
    <Container maxWidth='lg'>
      <m.div variants={varFade().in}>
        <Box sx={{ p: 5, mt: 10, textAlign: 'center' }}>
          <m.div variants={varFade().inDown}>
            <Typography variant='h3'>Noch Fragen?</Typography>
          </m.div>

          <m.div variants={varFade().inDown}>
            <Typography sx={{ mt: 3, mb: 5, color: 'text.secondary' }}>
              Wir freuen uns über Ihr Interesse und werden Ihre Frage möglichst genau beantworten.
            </Typography>
          </m.div>

          <m.div variants={varFade().inUp}>
            <NextLink href={PATH_PAGE.contact} passHref>
              <Button
                size='large'
                variant='contained'
                href={PATH_PAGE.contact}
              >
                Kontaktiere uns
              </Button>
            </NextLink>
          </m.div>
        </Box>
      </m.div>
    </Container>
  </RootStyle>
);